export default __webpack_public_path__ + "static/media/stripeIcon.4d6e527d.svg";